

























import BaseComponent from '@/components/base-component.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import UiAutocomplePatients from '../autocomplete-patients.vue';

@Component({
  components: { UiAutocompleClientsSubsidiaries, UiAutocomplePatients }
})
export default class UiReferencesTypesHierarchyPatient extends BaseComponent {
  @Prop()
  public item: any;
  @Prop({
    default: {
      patient: [],
      clientUnit: []
    }
  })
  public rules?: any;
  @Prop({
    default: false
  })
  public disabled: boolean;

  get patient(): string {
    return this.item.referenciaHierarquia;
  }

  set patient(val) {
    this.onChangePatient(val);
  }

  get clientUnit(): any {
    return this.item.unidade;
  }

  set clientUnit(val) {
    this.onChangeClientUnit(val);
  }

  @Watch('item.unidade')
  public onUnitChange(val: any): void {
    if (!val) {
      return;
    }
    this.clientUnit = val;
  }

  public beforeMount(): void {
    this.onUnitChange(this.item.unidade);
  }

  public onChangePatient(val: string): void {
    if (!val) {
      return;
    }
    this.$emit('changePatient', val);
  }

  public onChangeClientUnit(val: any): void {
    if (!val) {
      return;
    }
    this.$emit('changeClientUnit', val);
  }
}
